// extracted by mini-css-extract-plugin
module.exports = {"toggler":"ProductsDesktop_toggler__Btgfg","navList":"ProductsDesktop_navList__GodiO"};